module.exports = __webpack_public_path__ + "static/media/adobe.a264042d.svg";